module.exports = __webpack_public_path__ + "img/icon_l_kh_act.585e0a55.png";